import React from "react";
import { View, Text, ActivityIndicator } from "react-native";
import { useTheme } from "../providers/ThemeProvider";
import { Spacer } from "../components/ViewComponents";

export const LoadingScreen = (props: { message: string }) => {
  const theme = useTheme();
  return (
    <View
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.background,
      }}
    >
      <ActivityIndicator size="large" color={theme.backgroundText} />
      <Spacer size="medium" />
      <Text
        style={{ fontSize: theme.fontSize.body, color: theme.backgroundText }}
      >
        {props.message}
      </Text>
    </View>
  );
};
